export default __webpack_public_path__ + "static/media/instagram.3e4ff70a.svg";